import { watch, isRef, unref, onUnmounted, onDeactivated, nextTick, onMounted, onActivated } from '@vue/composition-api';
var inBrowser = typeof window !== 'undefined';

function onMountedOrActivated(hook) {
  var mounted;
  onMounted(function () {
    hook();
    nextTick(function () {
      mounted = true;
    });
  });
  onActivated(function () {
    if (mounted) {
      hook();
    }
  });
}

export function useEventListener(type, listener) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!inBrowser) {
    return;
  }

  var _options$target = options.target,
      target = _options$target === void 0 ? window : _options$target,
      _options$passive = options.passive,
      passive = _options$passive === void 0 ? false : _options$passive,
      _options$capture = options.capture,
      capture = _options$capture === void 0 ? false : _options$capture;
  var attached;

  var add = function add(target) {
    var element = unref(target);

    if (element && !attached) {
      element.addEventListener(type, listener, {
        capture: capture,
        passive: passive
      });
      attached = true;
    }
  };

  var remove = function remove(target) {
    var element = unref(target);

    if (element && attached) {
      element.removeEventListener(type, listener, capture);
      attached = false;
    }
  };

  onUnmounted(function () {
    return remove(target);
  });
  onDeactivated(function () {
    return remove(target);
  });
  onMountedOrActivated(function () {
    return add(target);
  });

  if (isRef(target)) {
    watch(target, function (val, oldVal) {
      remove(oldVal);
      add(val);
    });
  }
}